export function stripHtmlToPlainText(html: string): string {
  if (!html) return '';
  return html
    .replace(/<[^>]+>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

export function getDeveloperDescriptionHtml(developer: unknown): string | null {
  if (!developer || typeof developer !== 'object') return null;
  const d = developer as Record<string, unknown>;
  const desc = d.description;
  if (typeof desc === 'string' && desc.trim()) return desc;
  if (desc && typeof desc === 'object') {
    const o = desc as Record<string, string | undefined>;
    if (o.en?.trim()) return o.en;
    if (o.ru?.trim()) return o.ru;
    if (o.ar?.trim()) return o.ar;
  }
  return null;
}

export function getDeveloperDescriptionPlain(developer: unknown): string {
  const html = getDeveloperDescriptionHtml(developer);
  if (!html) return '';
  return stripHtmlToPlainText(html);
}

export function getDeveloperLogoUrl(property: {
  developer?: { logo?: string } | null;
  logo?: string;
}): string | null {
  const fromDev = property.developer && typeof property.developer === 'object' ? property.developer.logo : '';
  if (fromDev && String(fromDev).trim()) return String(fromDev).trim();
  if (property.logo && String(property.logo).trim()) return String(property.logo).trim();
  return null;
}
